'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _IconButton = require('@material-ui/core/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Button = require('@material-ui/core/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Toolbar = require('@material-ui/core/Toolbar');

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _Typography = require('@material-ui/core/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _Menu = require('@material-ui/icons/Menu');

var _Menu2 = _interopRequireDefault(_Menu);

var _Hidden = require('@material-ui/core/Hidden');

var _Hidden2 = _interopRequireDefault(_Hidden);

var _styles = require('@material-ui/core/styles');

var _withWidth = require('@material-ui/core/withWidth');

var _withWidth2 = _interopRequireDefault(_withWidth);

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _ButtonBase = require('@material-ui/core/ButtonBase');

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

var _styles2 = require('./styles');

var _styles3 = _interopRequireDefault(_styles2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BasicAppBar = function (_React$PureComponent) {
  _inherits(BasicAppBar, _React$PureComponent);

  function BasicAppBar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BasicAppBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BasicAppBar.__proto__ || Object.getPrototypeOf(BasicAppBar)).call.apply(_ref, [this].concat(args))), _this), _this.handleIconClick = function () {
      _this.props.toggleLeftDrawer();
    }, _this.renderLogo = function () {
      var _this$props = _this.props,
          classes = _this$props.classes,
          title = _this$props.title,
          logo = _this$props.logo,
          onLogoClick = _this$props.onLogoClick;

      if (logo) {
        return React.createElement(
          'div',
          {
            className: classes.logo,
            onClick: onLogoClick,
            onKeyPress: onLogoClick,
            role: 'button',
            tabIndex: '0'
          },
          React.createElement('img', { src: logo, alt: title, className: classes.image })
        );
      }
      return React.createElement(
        _ButtonBase2.default,
        { onClick: onLogoClick, className: classes.titleButton },
        React.createElement(
          _Typography2.default,
          { variant: 'title', color: 'inherit', className: classes.flex },
          title
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BasicAppBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          links = _props.links,
          menuIconAlways = _props.menuIconAlways,
          width = _props.width,
          classes = _props.classes;

      return React.createElement(
        _Toolbar2.default,
        { className: classes.wrapper },
        menuIconAlways || (0, _withWidth.isWidthDown)('xs', width) ? React.createElement(
          _IconButton2.default,
          { color: 'inherit', 'aria-label': 'Menu', onClick: this.handleIconClick },
          React.createElement(_Menu2.default, null)
        ) : null,
        this.renderLogo(),
        React.createElement(
          _Hidden2.default,
          { xsDown: true },
          React.createElement(
            'div',
            { className: classes.links },
            (0, _map2.default)(links, function (link) {
              return React.createElement(
                _Button2.default,
                {
                  onClick: link.onClick || null,
                  href: link.href || undefined,
                  color: 'inherit',
                  key: link.label
                },
                link.label
              );
            })
          )
        )
      );
    }
  }]);

  return BasicAppBar;
}(React.PureComponent);

BasicAppBar.defaultProps = {
  menuIconAlways: false
};
exports.default = (0, _compose2.default)((0, _withWidth2.default)(), (0, _styles.withStyles)(_styles3.default))(BasicAppBar);


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-layout/lib/templates/AppBar/BasicAppBar/BasicAppBar.js
// module id = 614
// module chunks = 61549186969478 79611799117203